export { default } from "./Pagination";
export { default as QueryPagination, type TProps as TQueryPaginationProps } from "./QueryPagination";
